import { Container, SceneObject } from '@cgs/wge';
import { AbstractIconResourceProvider } from './abstract_icon_resource_provider';

export abstract class AbstractMultisceneIconResourceProvider extends AbstractIconResourceProvider {
  protected constructor(container: Container) {
    super(container);
  }

  abstract getStaticIconNodes(iconId: string): SceneObject | null;
}
